import React from 'react';

const PostView = ({ data }) => (
    <div>
        <h1>Data Display</h1>
        <p>{data.map(post => (
            <li key={post.id}>
                <h2>{post.title}</h2>

            </li>
        ))}</p>
        <p>{data.title}</p>
        <p>{data.completed}</p>
        <a href="about">Test</a>
        <a href="service">Service</a>
    </div>
);

export default PostView;
